export default "__VITE_ASSET__b3efa01e__"